import {
  FETCH_REQUEST,
  FETCH_ERROR,
  SET_SELECTED_CAMPAIGNS,
  SET_SEARCH_DATES,
  SET_ISSKAN,
  SET_DOLLAR,
  FETCH_SELECTED_CAMPAIGNS_DATA,
  FETCH_FILTERED_DATA_FOR_PERFORMANCE,
  FETCH_DATA_FOR_REPORTING,
  FETCH_DATA_FOR_REPORTING_SKAN,
  FETCH_FILTERED_DATA_FOR_PERFORMANCE_UPDATED,
  FETCH_FILTERED_DATA_FOR_PERFORMANCE_UPDATEDV1,
  SET_STATIC_WIDZARDS_DATA,
  FETCH_PERFORMANCE_REQUEST,
  FETCH_WIDZARD_REQUEST,
  FETCH_WIDZARD_REQUEST_ERROR,
  SET_STATIC_WIDZARDS_DATA_SKAN,
  FETCH_REPORTING_REQUEST,
  FETCH_REPORTING_REQUEST_ERROR,
  APPLY_FILTER,
  FETCH_PERFORMANCE_REQUEST_ERROR,
  FETCH_EVENT_REQUEST,
  FETCH_EVENT_REQUEST_ERROR,
  FETCHED_EVENT_DATA,
  FETCH_ALL_DASHBORD_DATA,
  RESET_VIEW_DATA,
  SET_MAILER_DATE_RANGE,
  SET_MAILER_RECURRENCE,
  SET_HAS_OVERVIEW_DATA,
  SET_HAS_EVENTS_DATA
} from './campaignTypes';

import { addDays, format } from 'date-fns';

// ADD THIS HELPER FUNCTION HERE:
const getLocalDateString = (daysOffset = 0) => {
  const today = new Date();
  const targetDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + daysOffset,
    12, // Set to noon to avoid edge cases
    0,
    0
  );
  const year = targetDate.getFullYear();
  const month = String(targetDate.getMonth() + 1).padStart(2, '0');
  const day = String(targetDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const initialState = {
  loading: false,
  campaign_list: [],
  start_date: getLocalDateString(-2), // 2 days ago
  end_date: getLocalDateString(-1), // yesterday
  // Add new state for mailer date ranges
  mailer_start_date: getLocalDateString(-2), // Default to Daily (T-2)
  mailer_end_date: getLocalDateString(-1), // Default to Daily (T-1)
  mailer_recurrence: 'Daily', // Default recurrence

  isSkan: false,
  report: null,
  totalImpressions: 0,
  totalClicks: 0,
  totalMediaCost: 0,
  totalMediaCostLocalCurrency: 0,
  totalInstalls: 0,
  totalKPIEventCount: 0,
  totalSKANInstalls: 0,
  totalSkanEvent: 0,
  totalMmpEvent: 0,
  reportingData: [],
  performanceData: [],
  dataFetched: false,
  campaignMainData: [],
  performanceLoading: false,
  widzardLoading: false,
  reportLoading: false,
  eventDataLoading: false,
  applyFilter: false,
  eventReportingData: [],
  eventReportLoading: false,
  firstFilter: 0,
  dashboardData: [],
  error: '',
  isDollar: true,
  hasOverviewData: true,
  hasEventsData: true
};
const campaignReducer = (state = initialState, action) => {
  // console.log('campaignReducer ==> action.payload.result', action);
  switch (action.type) {
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true
      };
    case FETCH_PERFORMANCE_REQUEST: {
      return {
        ...state,
        performanceLoading: true,
        error: ''
      };
    }
    case FETCH_REPORTING_REQUEST: {
      return {
        ...state,
        reportLoading: true,
        reportingData: [],
        error: ''
      };
    }
    case FETCH_REPORTING_REQUEST_ERROR: {
      return {
        ...state,
        reportLoading: false,
        reportingData: [],
        error: action.payload
      };
    }
    case FETCH_EVENT_REQUEST: {
      return {
        ...state,
        eventReportLoading: true,
        eventReportingData: [],
        error: ''
      };
    }
    case FETCH_WIDZARD_REQUEST: {
      return {
        ...state,
        widzardLoading: true,
        totalImpressions: 0,
        totalClicks: 0,
        totalMediaCost: 0,
        totalInstalls: 0,
        totalSKANInstalls: 0,
        totalSkanEvent: 0,
        totalMmpEvent: 0,
        totalMediaCostLocalCurrency: 0
      };
    }
    case FETCH_WIDZARD_REQUEST_ERROR: {
      return {
        ...state,
        widzardLoading: false,
        totalImpressions: 0,
        totalClicks: 0,
        totalMediaCost: 0,
        totalInstalls: 0,
        totalSKANInstalls: 0,
        totalSkanEvent: 0,
        totalMmpEvent: 0,
        totalMediaCostLocalCurrency: 0
      };
    }
    case RESET_VIEW_DATA: {
      return {
        ...state,
        reportingData: [],
        eventReportingData: [],
        performanceData: [],
        totalImpressions: 0,
        totalClicks: 0,
        totalMediaCost: 0,
        totalMediaCostLocalCurrency: 0,
        totalInstalls: 0,
        totalSKANInstalls: 0,
        totalSkanEvent: 0,
        totalMmpEvent: 0,
        totalKPIEventCount: 0,
        error: ''
      };
    }
    case SET_SELECTED_CAMPAIGNS: {
      return {
        ...state,
        campaign_list: action.payload
      };
    }
    case SET_SEARCH_DATES: {
      return {
        ...state,
        start_date: action.payload.startDate,
        end_date: action.payload.endDate
      };
    }
    case SET_MAILER_DATE_RANGE:
      return {
        ...state,
        mailer_start_date: action.payload.startDate,
        mailer_end_date: action.payload.endDate
      };
    case SET_MAILER_RECURRENCE:
      return {
        ...state,
        mailer_recurrence: action.payload
      };
    case SET_ISSKAN: {
      return {
        ...state,
        isSkan: action.payload
      };
    }
    case SET_DOLLAR: {
      return {
        ...state,
        isDollar: action.payload
      };
    }
    case FETCH_SELECTED_CAMPAIGNS_DATA: {
      return {
        ...state,
        report: action.payload.campaignDetailsForAdvertiser
      };
    }
    case FETCH_FILTERED_DATA_FOR_PERFORMANCE: {
      return {
        ...state,
        performanceData: action.payload,
        dataFetched: true,
        applyFilter: false
      };
    }
    case FETCH_FILTERED_DATA_FOR_PERFORMANCE_UPDATED: {
      return {
        ...state,
        performanceData: action.payload,
        dataFetched: true,
        campaignMainData: action.payload.campaignMainData,
        loading: false,
        performanceLoading: false,
        applyFilter: false
      };
    }
    case FETCH_PERFORMANCE_REQUEST_ERROR:
      return {
        ...state,
        loading: false,
        campaign_list: [],
        error: action.payload,
        performanceLoading: false,
        campaignMainData: [],
        performanceData: [],
        totalImpressions: 0,
        totalClicks: 0,
        totalMediaCost: 0,
        totalInstalls: 0,
        totalKPIEventCount: 0,
        totalSKANInstalls: 0,
        totalSkanEvent: 0,
        totalMmpEvent: 0,
        reportingData: [],
        eventReportingData: []
      };

    case FETCH_FILTERED_DATA_FOR_PERFORMANCE_UPDATEDV1: {
      return {
        ...state,
        performanceDatav1: action.payload,
        dataFetched: true,
        loading: false,
        applyFilter: false
      };
    }

    case FETCH_DATA_FOR_REPORTING: {
      console.log('🔍 FETCH_DATA_FOR_REPORTING - Action payload:', action.payload);
      console.log('🔍 FETCH_DATA_FOR_REPORTING - Payload length:', action.payload?.length);
      return {
        ...state,
        reportingData: action.payload,
        loading: false,
        reportLoading: false,
        applyFilter: false,
        error: ''
      };
    }
    case FETCH_DATA_FOR_REPORTING_SKAN: {
      return {
        ...state,
        reportingData: action.payload,
        applyFilter: false
      };
    }
    case FETCH_ERROR:
      return {
        ...state,
        loading: false,
        campaign_list: [],
        error: (action.payload && action.payload.error) || (typeof action.payload === 'string' ? action.payload : '')
      };
    case FETCHED_EVENT_DATA: {
      return {
        ...state,
        eventReportingData: action.payload,
        loading: false,
        eventReportLoading: false,
        applyFilter: false
      };
    }
    case FETCH_EVENT_REQUEST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        eventReportLoading: false,
        eventReportingData: []
      };
    case SET_STATIC_WIDZARDS_DATA: {
      return {
        ...state,
        totalImpressions: action.payload?.impressions || 0,
        totalClicks: action.payload?.clicks || 0,
        totalMediaCost: action.payload?.media_cost || 0,
        totalMediaCostLocalCurrency: action.payload?.media_cost_local_currency || 0,
        totalInstalls: action.payload?.installs || 0,
        totalKPIEventCount: action.payload?.kpi_event_count || 0,
        loading: false,
        dataFetched: true,
        widzardLoading: false,
        applyFilter: false
      };
    }
    case SET_STATIC_WIDZARDS_DATA_SKAN: {
      return {
        ...state,
        totalImpressions: action.payload?.impressions || 0,
        totalClicks: action.payload?.clicks || 0,
        totalMediaCost: action.payload?.media_cost || 0,
        totalMediaCostLocalCurrency: action.payload?.media_cost_local_currency || 0,
        totalInstalls: action.payload?.installs || 0,
        totalSKANInstalls: action.payload?.skan_installs || 0,
        totalSkanEvent: action.payload?.skan_events || 0,
        totalMmpEvent: action.payload?.mmp_events || 0,
        loading: false,
        dataFetched: true,
        widzardLoading: false,
        applyFilter: false
      };
    }
    case APPLY_FILTER: {
      return {
        ...state,
        applyFilter: action.payload,
        firstFilter: state.firstFilter + 1
      };
    }
    case FETCH_ALL_DASHBORD_DATA: {
      return {
        ...state,
        dashboardData: action.payload
      };
    }
    case SET_HAS_OVERVIEW_DATA: {
      return {
        ...state,
        hasOverviewData: action.payload
      };
    }
    case SET_HAS_EVENTS_DATA: {
      return {
        ...state,
        hasEventsData: action.payload
      };
    }
    default:
      return state;
  }
};
export default campaignReducer;
